var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-content',[_c('v-select',{attrs:{"items":_vm.selectCompanies,"label":"소속회사","outlined":"","dense":"","value":_vm.company,"hide-details":""},on:{"change":_vm.update}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }